import {
  checkDemoInterviewAssesment,
  checkinterviewAssesment,
} from "./apiRoutes";
import instance from "./instance";

export const fetchInterviewDetails = async (token, interviewId) => {
  try {
    const response = await instance.get(
      `${checkinterviewAssesment}/${interviewId}/`,
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      },
    );

    if (response.status === 200) {
      return response.data || false;
    } else {
      throw new Error(`API responded with status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error in interview-details ", error);
  }
};

export const fetchTryInterviewDetails = async (token, interviewId) => {
  try {
    const response = await instance.get(
      `${checkDemoInterviewAssesment}/${interviewId}/`,
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      },
    );

    if (response.status === 200) {
      return response.data || false;
    } else {
      throw new Error(`API responded with status: ${response.status}`);
    }
  } catch (error) {
    console.error("Error in interview-details ", error);
  }
};
